<div class="maintenance-wrapper">
    <!-- <div class="title">Good bye!</div> -->
    <div class="content firstc">
        <p>
            Poštovani korisnici,
        </p>
        <p>
            Obaveštavamo vas da, posle tri godine uspešnog poslovanja, naš betting brend Victory.rs završava svoj
            rad.<br />
            Ova odluka, doneta nakon pažljivog razmatranja i analize tržišnih trendova, nije bila laka. Usled značajnih
            promena na tržištu i niza drugih faktora, došli smo do zaključka da je ovo najbolji put napred za našu
            kompaniju.<br />
        </p>
        <p>
            Vaša podrška i lojalnost bili su neprocenjivi tokom ovih godina, i duboko smo zahvalni na poverenju koje ste
            nam ukazali. Vaša strast prema igri je učinila naš brend posebnim, i zaista vam se zahvaljujemo na prilici
            da budemo vaš odabrani betting partner.
        </p>
    </div>
    <div class="content">
        <p>
            Važne informacije za vas:
        </p>
        <ol>
            <li>
                <strong>Isplata sredstava</strong>: Sva preostala sredstva na korisničkim računima biće isplaćena u
                skladu sa našim
                <a href="https://www.victory.rs/help/pravila-o-priredivanju-posebnih-igara-na-srecu">
                    pravilima
                </a>
                i definisanim rokovima. Molimo vas da proverite svoj račun i podnesete zahtev za isplatu što pre, kako
                bismo mogli da obradimo vaše transakcije blagovremeno.
            </li>
            <li>
                <strong>
                    Otvorene opklade
                </strong>:
                Sve otvorene opklade postavljene u okviru klađenja uživo ili pre početka meča će biti zaključene po
                završetku događaja, a korisnici će imati priliku da pregledaju otvorene opklade. Opklade postavljene na
                antepost događaje čiji ishod nije utvrđen do današnjeg datuma (4.3.2024.) će biti poništene i ulog će
                biti vraćen na korisničke račune.
            </li>
            <li>
                <strong>Zatvaranje računa</strong>:
                Vaši računi će biti privremeno zatvoreni za dalje korišćenje nakon isplate svih sredstava. Za bilo kakva
                dodatna pitanja ili potrebu za informacijama, naš tim za podršku je tu za vas.
            </li>
            <li>
                <strong>
                    Kontakt informacije
                </strong>:
                Naš tim za podršku ostaje vam na usluzi za sve upite ili potrebne informacije. Možete nas kontaktirati
                putem e-maila na adresi <a href="mailto:podrska&#64;victory.rs">podrska&#64;victory.rs</a>.
            </li>
        </ol>
    </div>
    <div class="content">
        <p>
            Hvala vam što ste bili deo naše priče.
        </p>
        <p>
            S poštovanjem i najlepšim željama za budućnost,
        </p>
        <p>
            Tim Victory.rs
        </p>
    </div>
</div>